export const overrideReasonOptions = [
  {
    value: "Vehicle Details not updated in VAHAN",
    key: "VAHAN_DETAILS_NOT_UPDATED"
  },
  {
    value: "Driver Details not updated in SARATHI",
    key: "SARATHI_DETAILS_NOT_UPDATED"
  }
];
